import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/lib/motion";

const faqs = [
  {
    q: "Nigdy nie ćwiczyłam. Czy to dla mnie?",
    a: "Tak — większość moich podopiecznych zaczyna od zera. Treningi 1:1 dopasowuję do Twojego poziomu, więc zaczynamy spokojnie i bezpiecznie.",
  },
  {
    q: "Ile razy w tygodniu trzeba trenować?",
    a: "Zwykle 2–3 treningi tygodniowo dają świetne efekty. Ustalimy grafik, który realnie zmieścisz w swoim tygodniu.",
  },
  {
    q: "Czy muszę być członkiem Zdrofit?",
    a: "Zdrofit oferuje szeroki wybór karnetów na siłownię oraz honoruje karty typu Multisport i podobne. Na konsultacji podpowiem, która opcja wejścia do Zdrofit Stegny będzie dla Ciebie najwygodniejsza.",
  },
  {
    q: "Czy podgląd AI to mój gwarantowany efekt?",
    a: "Nie — to poglądowa wizualizacja, która ma Cię zmotywować. Realny efekt zależy od pracy i planu, który wspólnie ułożymy.",
  },
];

export const Faq = () => (
  <section className="relative py-16 md:py-24 bg-[#0F0E0E]">
    <div className="max-w-[1000px] mx-auto px-6 md:px-10">
      <Reveal>
        <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B6B]">FAQ</span>
        <h2 className="font-display font-light text-4xl md:text-6xl mt-6 mb-14 leading-[0.95]">
          Najczęstsze pytania
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#2A2626]"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-xl md:text-2xl text-[#F5F2F0] hover:text-[#FF6B6B] hover:no-underline py-7">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted text-base leading-relaxed pb-7">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
